var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Icon from "../Icon";
import { darken } from 'polished';
import React from 'react';
import { color, layout, space, typography, } from 'styled-system';
import { css, styled } from "../../utils";
import Button from './Button';
var StyledButton = styled(Button)(function (_a) {
    var colors = _a.theme.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    line-height: 1.5;\n\n    svg {\n      transform: rotate(180deg);\n      background: ", ";\n      border-radius: 50%;\n      margin-right: 0.5rem;\n      padding: 0.23rem 0.4rem;\n\n      path {\n        fill: ", ";\n      }\n    }\n\n    &&:hover {\n      svg {\n        background: ", ";\n\n        path {\n          fill: ", ";\n        }\n      }\n    }\n  "], ["\n    line-height: 1.5;\n\n    svg {\n      transform: rotate(180deg);\n      background: ", ";\n      border-radius: 50%;\n      margin-right: 0.5rem;\n      padding: 0.23rem 0.4rem;\n\n      path {\n        fill: ", ";\n      }\n    }\n\n    &&:hover {\n      svg {\n        background: ", ";\n\n        path {\n          fill: ", ";\n        }\n      }\n    }\n  "])), colors.primary, colors.white, darken(0.05, colors.primary), colors.white);
}, layout, typography, space, color);
var BackButton = function (_a) {
    var label = _a.label, props = __rest(_a, ["label"]);
    return (React.createElement(StyledButton, __assign({ "data-component": "BackButton", shadow: false, ghost: true, paddingX: 0, width: "auto", color: "primary", alignItems: "flex-start" }, props),
        React.createElement(Icon.Arrow, null),
        label));
};
BackButton.defaultProps = {
    label: 'Zurück',
    display: 'flex',
};
export default BackButton;
var templateObject_1;
//# sourceMappingURL=BackButton.js.map